declare var window: any

import { Component } from "@angular/core"
import { NavParams, ViewController, ActionSheetController, ModalController, AlertController } from "ionic-angular"

import { UserService } from "../../services/user"
import { AppLocalStorage } from "../../services/app-local-storage"
import { ProfilePicturePage } from "./picture"
import { ProfileDataPage } from "./data"
import { ProfilePasswordPage } from "./password"
import { ProfileEmailPage } from "./email"

@Component({
  selector: "profile-page",
  templateUrl: "index.html",
})
export class ProfilePage {

  user: any = {}
  isLoggedUser = true
  isLoadingPicture = true

  constructor(
    private navParams: NavParams,
    private viewCtrl: ViewController,
    private actionSheetCtrl: ActionSheetController,
    private modalCtrl: ModalController,
    private alertCtrl: AlertController
  ) {

    const paramsUser = this.navParams.get("user")

    if (paramsUser) {
      this.isLoggedUser = false
      this.user = paramsUser
    } else {
      this.user = AppLocalStorage.get("user")
    }
  }

  ionViewWillEnter() {

    this.viewCtrl.setBackButtonText("Voltar")
  }

  onUpdate() {

    this.actionSheetCtrl.create({
      title: "O que você deseja atualizar ?",
      buttons: [
        {
          text: "Foto do perfil",
          handler: () => this.onUpdatePicture(),
        },
        {
          text: "Dados pessoais",
          handler: () => {

            const modal = this.modalCtrl.create(ProfileDataPage, { user: this.user })

            modal.onDidDismiss((user) => {

              if (user) {
                this.user = user
                this.updateUserData()
              }
            })

            modal.present()
          },
        },
        {
          text: "Senha de acesso",
          handler: () => {

            this.modalCtrl.create(ProfilePasswordPage).present()
          },
        },
        {
          text: "E-mail",
          role: "destructive",
          handler: () => {

            const modal = this.modalCtrl.create(ProfileEmailPage, { user: this.user })

            modal.onDidDismiss((email) => {

              if (email) {
                this.user.email = email
                this.updateUserData()
              }
            })

            modal.present()
          },
        },
        {
          text: "Cancelar",
          role: "cancel",
        },
      ],
    }).present()
  }

  onUpdatePicture() {

    if (!this.isLoggedUser)
      return

    const modal =  this.modalCtrl.create(ProfilePicturePage, { user: this.user })

    modal.onDidDismiss((picture) => {

      if (picture) {
        this.isLoadingPicture = true
        this.user.picture = picture
        this.updateUserData()
      }
    })

    modal.present()
  }

  updateUserData() {

    UserService.updateUserData(this.user)
      .catch((error) => {

        console.log(error)

        this.alertCtrl.create({
          message: "Falha ao atualizar dados no sistema de Gestão de Escalas",
          buttons: ["Ok"]
        }).present()
      })
  }

  openSocialPage(provider) {

    let url = ""

    if (provider == "linkedin") {
      url = "https://linkedin.com/in/" + this.user.social.linkedin
    } else if (provider == "facebook") {
      url = "https://facebook.com/" + this.user.social.facebook
    } else if (provider == "twitter") {
      url = "https://twitter.com/" + this.user.social.twitter
    }

    if (url)
      window.open(url, "_blank")
  }

  presentation() {

    let presentation = this.user.presentation

    if (!presentation) {
      presentation = this.isLoggedUser ? "Você" : this.user.firstName
      presentation += " ainda não escreveu uma apresentação pessoal"
    }

    return presentation
  }
}



// WEBPACK FOOTER //
// ./src/pages/profile/index.ts